import React from "react"
import axios from "axios";
import { Icon } from 'antd';
import { setup as URI_SETUP } from "../../../config/api";

const uri_users = URI_SETUP+"userrole";
const uri_modules_hotel = URI_SETUP+"contracted_module_hotel";
class EditUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title                 : "NEW USER",
            hotels                : [],
            modules               : [],
            selected_modules      : [],
            min_selected_modules  : [],
            user    :{
                        _id: "",
                        name: "",
                        lastname: "",
                        birthdate: "",
                        position: "",
                        email: "",
                        phone: "",
                        role: ""
                    },
            password :{
                password : "",
                confirm_password : ""
            },
            user_action           : "new",
            hotel_selected_status : "hide",
            hotel_checked_status  : "hide",
            selected_hotel        : "",
            selected_hotel_name   : "",
            fireExistError        : false,
            fireRequiredError     : false,
            loaded                : "hide",
            show_loading          : "",
            fireMatchError        : false,
            fireSecureError       : false
        }
    }

    componentWillMount(){
        this.checkUser();
    }

    checkUser(){
        if (this.props.editing_user != ""){
            this.setState({
                user_action : "edit",
                title : "EDIT INFO"
            })
            this.getUser();
        }else{
            this.setState({
                user_action : "new",
                loaded: "show",
                show_loading : "hide",
                title : "NEW USER"
            })
        }
    }

    handlePasswordChange = (e) => {
        let password = Object.assign({}, this.state.password);
        password[e.target.name] = e.target.value;
        this.setState({password});
    }
    
    handleUserChange = (e) => {
        let user = Object.assign({}, this.state.user);
        user[e.target.name] = e.target.value;
        this.setState({user});
    }
    
    getUser(){
        let self = this;
        var qs = require("qs");

        const userToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            user_id     : self.props.editing_user
        });
        axios.post(uri_users+"/getUser", userToSent)
                .then(request => { 
                    if(request.data["status"]== "success"){
                        var user = [];
                        var modules = [];
                        user._id     =  request.data.data._id;
                        user.name    =   request.data.data.name;
                        user.lastname=  request.data.data.lastname;
                        user.birthdate= request.data.data.birthdate;
                        user.position=  request.data.data.position;
                        user.email  =   request.data.data.email;
                        user.phone  =   request.data.data.phone;
                        user.role   =   request.data.data.sys_roll_id;
                        modules     =   request.data.data.modules;

                        self.setState({
                            user: user,
                            min_selected_modules: modules,
                            loaded: "show",
                            show_loading : "hide"
                        })

                        self.setSelectedModulesOnEdit();
                    }
                })
    }

    setSelectedModulesOnEdit(){
        let self = this;
        if(self.state.min_selected_modules!= null){
            Object.keys(self.state.min_selected_modules).map((key, index) => {
                self.getModulesByHotel(self.state.min_selected_modules[key].hotel_id, self.state.min_selected_modules[key].hotel_name);
            })
            self.setState({
                hotel_checked_status: "show"
            })
            self.renderSelectedModulesPanles();
        } else{
            self.setState({
                min_selected_modules : []
            })
        }
    }

    getModulesByHotel(hotel_id, hotel_name){
        let self = this;
        var exist = false;
        Object.keys(self.state.selected_modules).map((key, index) => {
            if(self.state.selected_modules[key].hotel_id == hotel_id){
                exist = true;
                self.state.selected_modules[key].visible = "show";
                self.setState({ 
                    modules : self.state.selected_modules[key].modules
                }) 
            }else{
                self.state.selected_modules[key].visible = "hide";
            }
        })
        if (exist == false){
            var qs = require("qs");
            const userToSent = qs.stringify({
                api_token   : localStorage.getItem("api_token"),
                business_id : self.props.business_id,
                hotel_id : hotel_id,
            });
            axios.post(uri_modules_hotel, userToSent)
                    .then(request => { 
                        self.setState({
                            modules : request.data
                        })
                        this.initializeSelectedModules(hotel_id, hotel_name);
                    })
        }
    }

    initializeSelectedModules(hotel_id, hotel_name){
        let self = this;
        let selected_modules = self.state.selected_modules;
        var hotel_selected = false;

        Object.keys(self.state.min_selected_modules).map((keyhot, index) => {
            if(self.state.min_selected_modules[keyhot].hotel_id == hotel_id){
                hotel_selected = true;
            }
        })
        var hotel_modules = ({
            hotel_id : hotel_id, 
            hotel_name : hotel_name,
            visible: "show", 
            selected: hotel_selected, 
            modules : self.state.modules 
        });

        Object.keys(hotel_modules.modules).map((key, index) => {
            var mod_selected = false;
            Object.keys(self.state.min_selected_modules).map((keyhot, index) => {
                if(self.state.min_selected_modules[keyhot].hotel_id == hotel_id){
                    Object.keys(self.state.min_selected_modules[keyhot].modules).map((keymod, index) => {
                        if(self.state.min_selected_modules[keyhot].modules[keymod].id == hotel_modules.modules[key].id) {
                            mod_selected = true;
                        }
                    })
                }
            })
            hotel_modules.modules[key].selected = mod_selected;

            Object.keys(hotel_modules.modules[key].panels).map((keypanels, index) => {
                var panel_selected = false;
                Object.keys(self.state.min_selected_modules).map((keyhot, index) => {
                    if(self.state.min_selected_modules[keyhot].hotel_id == hotel_id){
                        Object.keys(self.state.min_selected_modules[keyhot].modules).map((keymod, index) => {
                            if(self.state.min_selected_modules[keyhot].modules[keymod].id == hotel_modules.modules[key].id) {
                                Object.keys(self.state.min_selected_modules[keyhot].modules[keymod].panels).map((keypan, index) => {
                                    if(self.state.min_selected_modules[keyhot].modules[keymod].panels[keypan].id == hotel_modules.modules[key].panels[keypanels]._id) {
                                        panel_selected = true;
                                    }
                                })
                            }
                        })
                    }
                })
                hotel_modules.modules[key].panels[keypanels].selected = panel_selected;
            })
        })
        selected_modules.push(hotel_modules);

        self.setState({
            selected_modules : selected_modules,
            modules : hotel_modules.modules
        })
    }
    
    // Render 
    renderSelectedModulesPanles(){
        return Object.keys(this.state.selected_modules).map((keyhotels, index) => {
            if(this.state.selected_modules[keyhotels].selected){
                var str = this.state.selected_modules[keyhotels].hotel_name;
                var matches = str.match(/\b(\w)/g); 
                var acronym = matches.join(''); 

                return  (<div className={"selected-hotels modules"} key={this.state.selected_modules[keyhotels].hotel_id}>
                <span className="icon-module icon-hotel">{acronym}</span>
                <span className="hotel">{this.state.selected_modules[keyhotels].hotel_name}</span>
                {Object.keys(this.state.selected_modules[keyhotels].modules).map((key, index) => {
                    if(this.state.selected_modules[keyhotels].modules[key].selected){
                        return (<div className="selected-modules" key={this.state.selected_modules[keyhotels].modules[key].id}>
                                <span className={"icon-module " + this.state.selected_modules[keyhotels].modules[key].icon } style={{ backgroundColor: '#'+this.state.selected_modules[keyhotels].modules[key].color }}></span>
                                <span className="module-name"> {this.state.selected_modules[keyhotels].modules[key].name} </span>
                                {Object.keys(this.state.selected_modules[keyhotels].modules[key].panels).map((keypanel, index) => {
                                    if(this.state.selected_modules[keyhotels].modules[key].panels[keypanel].selected){
                                        return (<div className="selected-panels" key={this.state.selected_modules[keyhotels].modules[key].panels[keypanel]._id}>
                                            <span className={"icon-module " + this.state.selected_modules[keyhotels].modules[key].panels[keypanel].icon } style={{ backgroundColor: '#'+this.state.selected_modules[keyhotels].modules[key].panels[keypanel].color }}></span>
                                            <span className="module-name"> {this.state.selected_modules[keyhotels].modules[key].panels[keypanel].name} </span>
                                        </div>
                                        );
                                    }
                                })
                                }
                            </div>
                        );
                    }
                    })
                }
                </div>);
            }
            
        })
    }
    
    // On submit
    onSubmitUser(e){
        let self = this;
        e.preventDefault();
        self.setState({
            fireRequiredError: false,
            fireExistError: false
        })

        var qs = require("qs");

        const userToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            name        : self.state.user.name,
            lastname    : self.state.user.lastname,
            birthdate   : self.state.user.birthdate,
            position    : self.state.user.position,
            phone       : self.state.user.phone,
            action      : "basic"
        });
        axios.post(uri_users+"/"+self.state.user._id, userToSent)
        .then(response => { 
            if ( response.data["status"] === "success" ){
                self.props.setEditedNotification(true);
                self.props.getUsers(self.props.business_id);
                self.props.activeSection("account","account-data","","");
            }else{
                if(response.data["message"] === "required"){
                    self.setState({
                        fireRequiredError: true,
                        fireExistError: false
                    })
                }else{
                    self.setState({
                        fireRequiredError: false,
                        fireExistError: true
                    })
                }
            }
        })   
    }

    onSubmitPassword(e){
        let self = this;
        e.preventDefault();
        self.setState({
            fireMatchError: false,
            fireSecureError: false
        })

        if(self.state.password.password != self.state.password.confirm_password){
            self.setState({
                fireMatchError: true
            })
        }else{
            const  value = self.state.password.password;
            const re = new RegExp("^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$");
            const isOk = re.test(value);

            if(!isOk) {
                self.setState({
                    fireSecureError: true
                })
                console.log(value);
            }else{
                var qs = require("qs");

                const datatosend = qs.stringify({
                    api_token   : localStorage.getItem("api_token"),
                    user_id     : self.state.user._id,
                    password    : self.state.password.password
                });
                axios.post(uri_users+"/password", datatosend)
                    .then(response => { 
                        if ( response.data["status"] === "success" ){
                            localStorage.setItem("api_token", response.data["api_token"]);
                            self.props.setPasswordNotification(true);
                            self.props.getUsers(self.props.business_id);
                            self.props.activeSection("account","account-data","","");
                        }else{
                            self.setState({
                                fireRequiredError: false,
                                fireExistError: true
                            })
                        }
                    }) 
            }
        }
    }

    render() {
        return (
            <section>
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Account</h1>
                        <h2>Account info</h2>
                    </div>
                    <div className="col-md-3 px-2">     
                    </div>
                </div>
                <div className={"suscription "}> 
                    <div className="box regular col-lg-5 col-md-6">
                        <h3 className="title-roles-h3">{this.state.title}</h3>
                        <div className="scrollable content-role-user">
                           <div className="title-role">
                              <h4>User data</h4>
                           </div> 
                           <Icon className={this.state.show_loading} type="loading" />
                           <span className={"error-login " + (this.state.fireExistError === true ? "" : "hide")}>
                                User already exists
                            </span>
                           <span className={"error-login " + (this.state.fireRequiredError === true ? "" : "hide")}>
                                All data is required
                            </span>
                           <form className={"inputs-roles "+ this.state.loaded}  onSubmit={this.onSubmitUser.bind(this)}>
                                <div className="content-input-user">
                                    <input className="input-role" id="name2" name="name" placeholder="Name " value={(this.state.user.name==null)? "": this.state.user.name} required onChange={e => this.handleUserChange(e)} />
                                    <label>Name</label>
                                </div> 
                                <div className="content-input-user">
                                    <input className="input-role" name="lastname" placeholder="Last name " value={(this.state.user.lastname==null)? "": this.state.user.lastname} required onChange={e => this.handleUserChange(e)} />
                                    <label>Last name</label>
                                </div> 
                                <div className="content-input-user">
                                    <input type="date" className="input-role" name="birthdate" placeholder="Birth date " value={(this.state.user.birthdate==null)? "": this.state.user.birthdate} required onChange={e => this.handleUserChange(e)}  />
                                    <label>Birth date</label>
                                </div> 
                                <div className="content-input-user">
                                    <input className="input-role" name="position" placeholder="Position " value={(this.state.user.position==null)? "": this.state.user.position} required onChange={e => this.handleUserChange(e)}  />
                                    <label>Position</label>
                                </div> 
                                <div className="content-input-user">
                                    <input type="email" className="input-role" name="email" placeholder="E-mail " value={(this.state.user.email==null)? "": this.state.user.email} required onChange={e => this.handleUserChange(e)} disabled />
                                    <label>E-mail</label>
                                </div> 
                                <div className="content-input-user">
                                    <input className="input-role" name="phone" placeholder="Phone number " value={(this.state.user.phone==null)? "": this.state.user.phone} required onChange={e => this.handleUserChange(e)}  />
                                    <label>Phone number</label>
                                </div>  

                                <div className="content-select">
                                    <div className="buttons-user">
                                        <button onClick={this.props.activeSection.bind(this,"account","account-data","","")}>Cancel</button>
                                        <button className="btn-primary" type="submit">Save</button>
                                    </div>
                                </div>    
                            </form>

                            <div className="title-role">
                              <h4>Change password</h4>
                           </div> 
                            <span className={"error-login " + (this.state.fireMatchError === true ? "" : "hide")}>
                                Passwords do not match
                            </span>
                            <span className={"error-login " + (this.state.fireSecureError === true ? "" : "hide")}>
                                Password must contain at least 8 characters, uppercase, lowercase and numbers
                            </span>
                           <form className={"inputs-roles "+ this.state.loaded}  onSubmit={this.onSubmitPassword.bind(this)}>
                                <div className="content-input-user">
                                    <input type="password" className="input-role" name="password" placeholder="New password" required onChange={e => this.handlePasswordChange(e)}/>
                                    <label>New password</label>
                                </div> 
                                <div className="content-input-user">
                                    <input type="password" className="input-role" name="confirm_password" placeholder="Confirm password" required onChange={e => this.handlePasswordChange(e)}/>
                                    <label>Confirm password</label>
                                </div>
                                <div className="content-select">
                                    <div className="buttons-user">
                                        <button className="btn-primary" type="submit">Change</button>
                                    </div>
                                </div>      
                           </form>     
                         </div>       
                    </div> 
                    <div className={"box regular col-lg-5 col-md-7 " + this.state.hotel_checked_status}>
                        <h3>SUMMARY</h3>
                        <div className="scrollable content-role-user">
                            <div className="hotel-names">
                                <div className="title-role">
                                   <h4>Hotels - Modules</h4>
                                </div>
                                {this.renderSelectedModulesPanles()}
                            </div>
                         </div>       
                    </div> 
                </div>           
            </section>
        )
    }
}

export default EditUser


// WEBPACK FOOTER //
// ./src/Setup/modules/account/views/EditUser.js